import {Component} from '@angular/core';
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class AppComponent {
    title = 'fm-maintenance-assignation-frontend';

    constructor(private translate: TranslateService) {
        translate.setDefaultLang('en');
    }
}
